
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'oxd-grid-item',
  props: {
    gutters: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    classes(): object {
      return {
        'oxd-grid-item': true,
        'oxd-grid-item--gutters': this.gutters,
      };
    },
  },
});
